var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "One") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F44336"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.529412, 6.588235)",
    stroke: "#FFFFFF",
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    strokeWidth: 1.87076921,
    points: "8.28325506 0.084596064 0 5.08883646 0 14.4018558 8.28390769 19.3312856 16.6555668 14.4265954 16.6555668 5.09040863"
  }), /*#__PURE__*/React.createElement("polygon", {
    strokeWidth: 0.935384604,
    points: "7.96518444 11.211911 8.4790673 11.211911 8.4790673 18.5126903 7.96518444 18.5126903"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneWeb);
export default __webpack_public_path__ + "static/media/one-web.6f3963b7ec4d173dfc8fd12afac9f0d9.svg";
export { ForwardRef as ReactComponent };